export default {"src":"/_next/static/media/logo-4.017f553b.svg","height":41,"width":44,"blurWidth":0,"blurHeight":0};